<template>
  <b-form-invalid-feedback :state="!errors" v-if="errors">
    <template v-if="Array.isArray(errors)">
      <div v-for="(item, index) in errors" :key="index">
        {{ item }}
      </div>
    </template>
    <template v-else>
      {{ errors }}
    </template>
  </b-form-invalid-feedback>
</template>

<script>
export default {
  props: [ 'errors' ],
}
</script>

<style lang="scss">
</style>
